<div class="py-3" *ngIf="vm$ | async as vm;">
    <ng-container *ngIf="vm.initialized else loading">
        <qwyk-magaya-network-create
            (create)="onCreateMagayaNetworkConfiguration($event)"
            *ngIf="vm.magayaNetworkConfiguration === null"
            [error]="vm.error"
            [loading]="vm.loading"
            [organization]="organization"
        >
        </qwyk-magaya-network-create>

        <ng-container *ngIf="!edit">
            <qwyk-magaya-network-detail
                (edit)="onEdit(vm.magayaNetworkConfiguration)"
                (testConnection)="onTestNetworkConfiguration($event)"
                *ngIf="vm.magayaNetworkConfiguration"
                [error]="vm.error"
                [loading]="vm.loading"
                [magayaNetworkConfiguration]="vm.magayaNetworkConfiguration"
                [organization]="organization"
            ></qwyk-magaya-network-detail>
        </ng-container>
    </ng-container>

    <ng-template #loading>
        <div class="py-3 text-center">
            <img src="https://cdn.qwyk.io/portals/assets/providers/catapult-qms.png" style="opacity: .8" width="180">
            <p class="text-muted m-0">{{ 'common.loading' | translate }} {{ 'hub.console.organizations.magaya-network-configuration' | translate }}...</p>
        </div>
    </ng-template>
</div>
